import { InjectionToken } from "@angular/core";
import { IAppUserNotificationsService } from "./app-user-notifications.service";

export const APP_USER_NOTIFICATIONS_SERVICE_TOKEN = new InjectionToken<IAppUserNotificationsService>('App user notifications service interface token');
